import { Settings } from "react-slick";

const ConfiguracoesCarrosselPadrao : Settings = {
  lazyLoad: "ondemand",
  speed: 300,
  infinite: false,
  arrows: false,
  variableWidth: true,
  slidesToShow: 4.2,
  slidesToScroll: 4,
  responsive: [{
    breakpoint: 900,
    settings: {
      slidesToShow: 3.2,
      slidesToScroll: 3,
    }
  },
  {
    breakpoint: 767,
    settings: {
      slidesToShow: 2.2,
      slidesToScroll: 2,
    }
  }]
};

export const ConfiguracoesCarrosselPadraoVW : Settings = {
  speed: 300,
  infinite: false,
  variableWidth: true,
  arrows: false,
  slidesToScroll: 2
};

export const ConfiguracoesCarrosselCategoriaVW : Settings = {
  speed: 300,
  infinite: false,
  variableWidth: true,
  slidesToScroll: 2,
  arrows: false,
};

export default ConfiguracoesCarrosselPadrao;